import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/4eb12e47-adf8-4d57-b68f-0832189a7b85";
export const REGISTER_URL = "https://a.ntrk2.com/c3f82852-f7f0-4412-bfd3-90486747f602";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://topcop.kzw2a.com/download?openExternalBrowser=1&id=0kkblnhel7zcpke";

export * from "./codes";
export * from "./context";
